export const getSubscriptionLink = () => 'https://www.boutique-happyneuron.com/32-abo-mensuels';

export const openSubscribtion = () => window.open(getSubscriptionLink(), '_blank');
